
export default class AgencyLabelDto {
    company = '';
    companies = '';
    companyOwns = '';
    location = '';
    locations = '';
    locationOwns = '';
    worker = '';
    workers = '';
    workerOwns = '';
    externalAccountingSystemCategory1 = '';
    externalAccountingSystemCategory2 = '';
}